exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-border-box-1{position:relative;width:100%;height:100%}.dv-border-box-1 .border{position:absolute;display:block}.dv-border-box-1 .right-top{right:0;transform:rotateY(180deg)}.dv-border-box-1 .left-bottom{bottom:0;transform:rotateX(180deg)}.dv-border-box-1 .right-bottom{right:0;bottom:0;transform:rotateX(180deg) rotateY(180deg)}.dv-border-box-1 .border-box-content{position:relative;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/borderBox1/src/main.css
// module id = 1072
// module chunks = 45